import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import { CommonMessage } from '@frontend/lang';
import { User } from '@frontend/user/utils';
import { LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import useKioskUserModal from './kiosk-user-modal.controller';

const ID = 'kiosk-user-modal';

export interface KioskUserModalProps {
    show: boolean;
    onClose: () => void;
}

export const KioskUserModal = (props: KioskUserModalProps) => {
    const viewProps = useKioskUserModal();

    if (!viewProps.user) {
        return null;
    }

    const user = new User(viewProps.user);

    return (
        <DefaultModal
            id={ID}
            handleClose={props.onClose}
            show={props.show}
            type={ModalType.PROMPT}
            className='bg-background-surface m-12 overflow-hidden rounded-2xl p-6'>
            <div className='flex flex-col items-center justify-start gap-6 self-stretch'>
                <div className='flex flex-col items-start justify-start gap-6 self-stretch'>
                    <div className='flex h-6 items-start justify-between self-stretch'>
                        <div className='text-foreground-default text-xl font-semibold'>
                            <FormattedMessage
                                id='kiosk.userModal.title'
                                defaultMessage='Signed in as'
                                description='Title for the kiosk user modal, indicating the current signed-in user'
                            />
                        </div>
                        <button
                            className='relative flex size-6 cursor-pointer items-center justify-center overflow-hidden'
                            onClick={props.onClose}
                            data-testid='user-modal-close-button'>
                            <LuX className='text-foreground-default size-6' />
                        </button>
                    </div>
                </div>
                <div className='flex flex-col items-center justify-start gap-3 self-stretch p-4'>
                    <div className='bg-brand-secondary flex size-14 items-center justify-center rounded-full'>
                        <span className='text-background-surface justify-start text-center text-2xl font-semibold'>{user.getInitials()}</span>
                    </div>
                    <div className='flex flex-col items-center justify-start gap-1'>
                        <p className='text-xl font-semibold'>{user.getDisplayName()}</p>
                        {user.unique_identifier && <p className='text-sm font-medium'>{user.unique_identifier}</p>}
                    </div>
                </div>
                <div className='flex items-start justify-end gap-3 self-stretch'>
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.CLOSE}
                        onClick={props.onClose}
                        dataTestId='user-modal-close-button-secondary'
                    />
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.EXIT_KIOSK}
                        onClick={() => {
                            viewProps.onLogout();
                            props.onClose();
                        }}
                        dataTestId='user-modal-exit-button'
                    />
                </div>
            </div>
        </DefaultModal>
    );
};
